import React from 'react';
import ResultDragonTiger from '../resultDragonTiger/ResultDragonTiger';

/**
 * 20-20 Dragon Tiger 2 (dt202) uses the same reference component as dt20
 * (the reference renders <DragonTigerT20 gtype="dt202">), so its Last Result items
 * and result modal are the dt20 ones fed with the dt202 API type.
 */
const ResultDragonTiger202 = (props) => <ResultDragonTiger gameType="dt202" {...props} />;

export default ResultDragonTiger202;
